export default {
  isLoggedIn: false,
  licenses: [],
  primaryLicense: '',
  balance: 0,
  authToken: '',
  email: '',
  fullName: '',
  firstName: '',
  prefix: '',
  lastName: '',
  orders: [],
  invoices: [],
  articles: [],
  relationId: 0,
  cardNumber: 0,
  role: 0,
  street: '',
  houseNumber: '',
  zipCode: '',
  city: '',
  businessName: '',
  vatNumber: '',
};
